/*
 * @Author: cgh
 * @Date: 2022-08-01 10:49:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-07 17:26:20
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const wtlbManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfpg/pgwt`, { params: params }); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfpg/pgwt/save`, fd); },

  // 修改
  update: (fd) => { return axios.put(`${iffApi}/xfpg/pgwt`, fd); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfpg/pgwt/${id}`); },

  // 详情
  getDetail: (id) => { return axios.get(`${iffApi}/xfpg/pgwt/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfpg/pgwt/export`, { responseType: 'blob', params }); }
};
